<template>
  <div class="sticky top-0 z-50">
    <!-- NAVBAR -->
    <nav
      id="navbar"
      :class="[
        'relative z-50 border-b border-gray-200/70 bg-white/90 backdrop-blur-md transition-shadow',
        isMenuOpen ? '' : 'shadow-sm',
      ]"
    >
      <div class="mx-auto flex max-w-[1700px] items-center justify-between gap-6 px-4 py-3 sm:px-6 xl:px-8">
        <!-- Logo -->
        <router-link
          to="/"
          @click="closeMenu"
          class="z-50 flex flex-col items-start leading-tight"
        >
          <span class="font-serif text-[22px] sm:text-2xl font-bold text-brand-red">সাংস্কৃতিক দাপোণ</span>
          <span class="text-xs sm:text-[13px] font-medium tracking-wide text-brand-red-dark/80">
            Cultural Newspapers Dapon
          </span>
        </router-link>

        <!-- Hamburger Icon -->
        <button
          @click="toggleMenu"
          class="lg:hidden z-50 rounded-md p-2 text-gray-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red/40"
          :aria-label="isMenuOpen ? 'Close menu' : 'Open menu'"
          :aria-expanded="isMenuOpen"
        >
          <div class="w-6 h-6 relative">
            <span
              :class="[
                'absolute w-full h-0.5 rounded bg-current left-0 transition-transform duration-300',
                isMenuOpen ? 'rotate-45 top-3' : 'top-1',
              ]"
            ></span>
            <span
              :class="[
                'absolute w-full h-0.5 rounded bg-current left-0 transition-opacity duration-300',
                isMenuOpen ? 'opacity-0' : 'top-3',
              ]"
            ></span>
            <span
              :class="[
                'absolute w-full h-0.5 rounded bg-current left-0 transition-transform duration-300',
                isMenuOpen ? '-rotate-45 top-3' : 'top-5',
              ]"
            ></span>
          </div>
        </button>

        <!-- DESKTOP LINKS -->
        <div class="hidden lg:flex items-center">
          <ul class="flex items-center gap-7 text-[15px] font-medium text-gray-600">
            <li><router-link to="/" class="nav-link">Home</router-link></li>
            <li>
              <router-link to="/gallery" class="nav-link">Gallery</router-link>
            </li>
            <li>
              <router-link to="/about" class="nav-link">About Us</router-link>
            </li>
            <li>
              <router-link to="/suggestion" class="nav-link"
                >Suggestion</router-link
              >
            </li>
            <li>
              <router-link to="/contact" class="nav-link">Contact Us</router-link>
            </li>
          </ul>
        </div>

        <!-- DESKTOP BUTTONS -->
        <div class="hidden lg:flex items-center gap-4">
          <template v-if="!loggedIn">
            <router-link
              to="/login"
              class="btn-outline"
              >শিল্পীয়ে নিজৰ পৰিচয় প্ৰকাশ কৰক</router-link
            >

            <div
              class="hidden xl:flex flex-col items-end leading-tight border-l border-gray-200 pl-5"
            >
              <span class="font-serif text-2xl font-bold text-brand-red">সাংস্কৃতিক আলোচনী দাপোণ</span>
              <span class="text-[13px] font-medium tracking-wide text-brand-red-dark/80">
                Cultural Magazine Dapon
              </span>
            </div>
          </template>

          <template v-else>

            <div class="flex items-center gap-2 rounded-md border border-gray-200 bg-white py-1 pl-1 pr-3">
              <!-- Avatar Circle -->
              <div class="w-8 h-8 rounded-full bg-brand-red flex items-center justify-center text-white font-bold text-sm">
                {{ userInitial }}
              </div>
              <!-- Name -->
              <span class="text-gray-700 font-medium text-sm max-w-[150px] truncate" :title="userName">
                Hi, {{ userName }}
              </span>
            </div>

            <router-link
              v-if="userRole === 'admin'"
              to="/admin/dashboard"
              class="btn-cream"
              >Admin Dashboard</router-link
            >
            <router-link
              v-else
              to="/artist"
              class="btn-cream"
              >Profile</router-link
            >

            <button
              @click="logout"
              class="btn-primary"
            >
              Logout
            </button>
          </template>
        </div>
      </div>
    </nav>



    <!-- MOBILE MENU -->
    <transition name="menu">
      <div
        v-if="isMenuOpen"
        class="fixed inset-0 bg-white z-40 flex flex-col items-center justify-center px-6 pt-20 pb-10 lg:hidden"
      >
        <ul class="text-center space-y-5 font-serif text-2xl font-semibold text-gray-800">
          <li>
            <router-link @click="closeMenu" to="/" class="mobile-link"
              >Home</router-link
            >
          </li>
          <li>
            <router-link @click="closeMenu" to="/gallery" class="mobile-link"
              >Gallery</router-link
            >
          </li>
          <li>
            <router-link @click="closeMenu" to="/about" class="mobile-link"
              >About Us</router-link
            >
          </li>
          <li>
            <router-link @click="closeMenu" to="/suggestion" class="mobile-link"
              >Suggestion</router-link
            >
          </li>
          <li>
            <router-link @click="closeMenu" to="/contact" class="mobile-link"
              >Contact Us</router-link
            >
          </li>

          <template v-if="loggedIn">

            <li>
               <router-link v-if="userRole === 'admin'" @click="closeMenu" to="/admin/dashboard" class="mobile-link"
                >Admin Dashboard</router-link
              >
              <router-link v-else @click="closeMenu" to="/artist" class="mobile-link"
                >Profile</router-link
              >
            </li>
          </template>
        </ul>

        <!-- MOBILE BUTTONS -->
        <div
          class="absolute bottom-10 flex flex-col items-stretch gap-3 w-full max-w-sm px-6"
        >
          <template v-if="!loggedIn">
            <router-link
              @click="closeMenu"
              to="/login"
              class="btn-outline py-3"
              >শিল্পীয়ে নিজৰ পৰিচয় প্ৰকাশ কৰক</router-link
            >

            <router-link
              @click="closeMenu"
              to="/subscribe"
              class="btn-cream py-3"
              >Subscribe</router-link
            >
          </template>

          <template v-else>
            <button
              @click="logoutAndClose"
              class="btn-primary py-3"
            >
              Logout
            </button>
          </template>
        </div>
      </div>
    </transition>
  </div>
</template>


<script setup>
import { ref, onMounted, watch, computed } from "vue";
import gsap from "gsap";
import { useRoute } from "vue-router";

const isMenuOpen = ref(false);
const loggedIn = ref(false);
const userName = ref(""); // New reactive state for the user's name/email
const userRole = ref("");
const route = useRoute();

function toggleMenu() {
  isMenuOpen.value = !isMenuOpen.value;
}



function logout() {
  localStorage.removeItem("token");
  localStorage.removeItem("user"); // IMPORTANT: Also remove the user object
  loggedIn.value = false;
  userName.value = ""; // Clear the user name
  window.location.href = "/login";
}

function closeMenu() {
  isMenuOpen.value = false;
}

function logoutAndClose() {
  logout();
  closeMenu();
}

function checkLogin() {
  const token = localStorage.getItem("token");
  const userString = localStorage.getItem("user");

  if (token && userString) {
    try {
      const user = JSON.parse(userString);
      loggedIn.value = true;
      // Display the user's name, fallback to email or "User"
      userName.value = user.name || user.email || "User";
      userRole.value = user.role || "user";
    } catch (e) {
      console.error("Error parsing user data:", e);
      loggedIn.value = false;
      userName.value = "";
      userRole.value = "";
    }
  } else {
    loggedIn.value = false;
    userName.value = "";
    userRole.value = "";
  }
}

onMounted(() => {
  gsap.from("#navbar", {
    y: -100,
    opacity: 0,
    duration: 0.8,
    ease: "power3.out",
  });
  // Sticky navbar: hide while scrolling down, reveal when scrolling up
  let lastScroll = window.scrollY;
  window.addEventListener("scroll", () => {
    const currentScroll = window.scrollY;
    if (!isMenuOpen.value && currentScroll > lastScroll && currentScroll > 80) {
      gsap.to("#navbar", {
        y: -100,
        duration: 0.4,
        ease: "power2.out",
      });
    } else if (currentScroll < lastScroll || currentScroll <= 80) {
      gsap.to("#navbar", {
        y: 0,
        duration: 0.4,
        ease: "power2.out",
      });
    }
    lastScroll = currentScroll;
  }, { passive: true });
  checkLogin();
});
// Re-check login status when the route changes
watch(
  () => route.fullPath,
  () => {
    checkLogin();
  }
);

const userInitial = computed(() => {
  return userName.value ? userName.value.charAt(0).toUpperCase() : "?";
});
</script>

<style scoped>
.nav-link {
  position: relative;
  display: inline-block;
  padding: 0.25rem 0;
  transition: color 0.2s ease;
}
.nav-link:hover,
.nav-link.router-link-exact-active {
  color: #d84040;
}
.nav-link::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  height: 2px;
  width: 100%;
  border-radius: 2px;
  background-color: #d84040;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.25s ease;
}
.nav-link:hover::after,
.nav-link.router-link-exact-active::after {
  transform: scaleX(1);
}

.mobile-link {
  transition: color 0.2s ease;
}
.mobile-link:hover,
.mobile-link.router-link-exact-active {
  color: #d84040;
}

.menu-enter-active,
.menu-leave-active {
  transition: opacity 0.25s ease;
}
.menu-enter-from,
.menu-leave-to {
  opacity: 0;
}
</style>
